import { Injectable } from '@angular/core';
import * as amplitude from '@amplitude/analytics-browser';
import { AppConfigService } from './app-config.service';

declare global {
  interface Window {
    amplitude: typeof amplitude;
  }
}

@Injectable({
  providedIn: 'root',
})
export class AmplitudeService {
  private readonly amplitudeKey: string;
  private initialized: boolean = false;

  constructor(private appConfigService: AppConfigService) {
    this.amplitudeKey = this.appConfigService.getAmplitudeKey();
  }

  private hasAmplitudeKey(): boolean {
    return typeof this.amplitudeKey === 'string' && this.amplitudeKey.length > 0;
  }

  public initialiseAmplitude(): void {
    if (!this.hasAmplitudeKey() || this.initialized) {
      return;
    }

    amplitude.init(this.amplitudeKey, {
      fetchRemoteConfig: true,
      autocapture: true,
      cookieOptions: {
        secure: true,
      },
    });

    window.amplitude = amplitude;

    this.initialized = true;
  }
}
